const formatNumberShortFloor = (n, decimals = 1) => {
  if (n < 1e3) return n.toString();
  const units = ["k", "M", "B"];
  const order = Math.floor(Math.log10(n) / 3);
  const unit = units[order - 1];
  const num = n / 1e3 ** order;
  const factor = 10 ** decimals;
  const floored = Math.floor(num * factor) / factor;
  return `${floored.toFixed(decimals)}${unit}`;
};

export { formatNumberShortFloor };
//# sourceMappingURL=convertXp.js.map
